import DataStoreRecordBehaviors from '../collaboration/DataStoreRecordBehaviors';
import { type DocData } from '../collaboration/Serialization';

export const customShapeSerializedKeys = ['id', 'name', 'objects'] as const;

type CustomShapeKeys = (typeof customShapeSerializedKeys)[number];
export type CustomShapeClipboardData = {
  [K in CustomShapeKeys]: CustomShape[K];
};
export class CustomShape extends DataStoreRecordBehaviors(Object) {
  name: string;
  id: RecordId;
  objects: DocData['objects'];
  serializedKeys = [...customShapeSerializedKeys];

  constructor({
    name,
    objects,
    id,
  }: {
    name: string;
    objects: DocData['objects'];
    id?: RecordId;
  }) {
    super();
    this.name = name;
    this.objects = objects;
    this.id = id;
  }
}
